import PropTypes from "prop-types"
import { Controller } from "react-hook-form"

import Textarea from "components/ui/textarea"

const GiftCardDarkTextArea = ({ control, name, placeholder }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <Textarea
          error={error}
          id={name}
          placeholder={placeholder}
          rows="3"
          {...field}
        />
      )}
    />
  )
}

GiftCardDarkTextArea.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
}

export default GiftCardDarkTextArea
